import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = "[ ORDERS AUTH ]";

const Actions = {
  fetchOrderData: `${MODULE_PREFIX} fetchOrderData`,
  setOrderData: `${MODULE_PREFIX} setOrderData`,
  resetOrdersAuth : `${MODULE_PREFIX} resetOrdersAuth`,
};

//Actions
export const fetchOrderData = createAction(Actions.fetchOrderData);
export const setOrderData = createAction(Actions.setOrderData);
export const resetOrdersAuth = createAction(Actions.resetOrdersAuth);

//Selectors
export const getOrdersAuthData = (state) => {
  return get(state, "ordersAuth.orderData", {});
};

//Initial State
const initialState = {
  orderData : {}
}

//Reducers
export default createReducer(initialState, (builder) => {
  builder.addCase(setOrderData, (state, action) => {
    state.orderData = action.payload
  })
  builder.addCase(resetOrdersAuth, (state) => {
    state.orderData = {}
  })
});